import type { ComponentType } from "react";

const calendarHeader = new URL("../../../../img/julekalender_header.png", import.meta.url).toString();
const calendarHeaderMobile = new URL("../../../../img/julekalender_header_mobil.png", import.meta.url).toString();
export const AdventCalendarHeader: ComponentType = () => {
   return (
      <>
         <img className="w-full h-full hidden sm:block" src={calendarHeader} alt="Julekalender-header" />
         <img className="w-full h-full block sm:hidden" src={calendarHeaderMobile} alt="Julekalender-header-mobil" />
      </>
   );
};
